import request from '@/utils/request'

//添加
export function add(params,data) {
    return request({
        url: `/api/TrainTask/Add`,
        method: 'post',
        params,
        data
    })
}

//获取
export function getList(params) {
    return request({
        url: '/api/TrainTask/GetList',
        method: 'get',
        params
    })
}

//修改
export function updateTask(params,data) {
    return request({
        url: '/api/TrainTask/Update',
        method: 'post',
        params,
        data
    })
}

//获取树
export function getTree(params) {
    return request({
        url: '/api/TrainTask/GetTree',
        method: 'get',
        params
    })
}

//查询报送名单
export function getTaskPeople(params) {
    return request({
        url: '/api/TrainTask/GetTaskPeople',
        method: 'get',
        params
    })
}

//查询报送负责人
export function getTaskManager(params) {
    return request({
        url: '/api/TrainTask/GetTaskManager',
        method: 'get',
        params
    })
}

//查询单位报名数量
export function getTaskDeptCount(params) {
    return request({
        url: '/api/TrainTask/GetTaskDeptCount',
        method: 'get',
        params
    })
}

//查询个人中心培训班报名任务
export function getCenterTaskTrain(params) {
    return request({
        url: '/api/TrainTask/GetCenterTaskTrain',
        method: 'get',
        params
    })
}
